import { Component } from 'react';
import store, {history} from '../../../../store';
import IgniteDataTable from '../../../common/datatable';
import ConfirmPopup from '../../../common/confirm-popup';
import {deleteNotification} from '../../../../actions/notifications';

class NotificationList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  render() {
    // AMS's json_api adapter dasherises attribute keys, hence 'site-message'.
    const CHANNELS = [
      ['email', 'Email'],
      ['sms', 'SMS'],
      ['site-message', 'Site Message'],
      ['push', 'Push'],
    ];

    const columns = [
      {
        prop: 'event',
        title: 'Events'
      },
      {
        prop: 'custom-to',
        title: 'Recipient'
      },
      {
        prop: 'event',
        title: 'Channels',
        // renderNested passes row.original as the second format arg, so the raw resource -
        // including its attributes - is available here.
        format: (value, row) => CHANNELS
          .filter(([key]) => row.attributes[key])
          .map(([, label]) => label)
          .join(', ')
      },
    ];

    const actions = [
      {
        label: 'Edit',
        permissions: {
          action: 'update',
          subjectClass: 'Notification'
        },
        callback: (row) => {
          history.push(`/admin/notifications/${row.id}`);
        }
      },
      {
        label: 'Delete',
        color: 'grey',
        permissions: {
          action: 'destroy',
          subjectClass: 'Notification',
        },
        callback: (row) => {
          this.setState({
            delete: {
              show: true,
              id: row.id
            }
          });
        }
      }
    ];

    const handleDelete = (result) => {
      const {id} = this.state.delete;
      this.setState({delete: {show: false}});
      if (result) {
        store.dispatch(deleteNotification(id));
      }
    };

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={this.props.notifications}
        />

        {
          this.state.delete.show && (
            <ConfirmPopup
              header="DELETE NOTIFICATION?"
              onClose={handleDelete}
            >
              <p>
                Are you sure you want to delete the selected notification?
              </p>
            </ConfirmPopup>
          )}
      </div>
    );
  }
}

export default NotificationList;
